import { render, staticRenderFns } from "./devChecklist.vue?vue&type=template&id=2282e3c8&"
import script from "./devChecklist.vue?vue&type=script&lang=js&"
export * from "./devChecklist.vue?vue&type=script&lang=js&"
import style0 from "./devChecklist.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports